<script>
</script>

<div class="not-found">
  <h1>404 - Page Not Found</h1>
  <p>Oops! We couldn't find the page you're looking for.</p>
  <p>The requested URL was not found on this server.</p>
  <a href="/">Go back to homepage</a>
</div>

<style>
  .not-found {
    text-align: center;
    padding: 2rem;
    font-family: Arial, sans-serif;
  }

  h1 {
    color: #e74c3c;
  }

  a {
    display: inline-block;
    margin-top: 1rem;
    padding: 0.5rem 1rem;
    background-color: #3498db;
    color: white;
    text-decoration: none;
    border-radius: 4px;
  }

  a:hover {
    background-color: #2980b9;
  }
</style>
